import { isArdoqError, type Result } from '@ardoq/common-helpers';
import type { BulkDeleteComponentCount } from '../../types';

export type BulkDeleteCount =
  | { status: 'loading' }
  | { status: 'loaded'; counts: BulkDeleteComponentCount }
  | { status: 'error' };

const toBulkDeleteCount = (
  result: Result<BulkDeleteComponentCount>
): BulkDeleteCount =>
  isArdoqError(result)
    ? { status: 'error' }
    : { status: 'loaded', counts: result };

const getDeletableCount = (count: BulkDeleteCount): number | null =>
  count.status === 'loaded' ? count.counts.deletable : null;

/** `null` rather than none while we do not know */
const getBlockedCount = (count: BulkDeleteCount): number | null =>
  count.status === 'loaded'
    ? Math.max(count.counts.total - count.counts.deletable, 0)
    : null;

const isSubmittable = (count: BulkDeleteCount): boolean =>
  (getDeletableCount(count) ?? 0) > 0;

export const bulkDeleteOperations = {
  toBulkDeleteCount,
  getDeletableCount,
  getBlockedCount,
  isSubmittable,
};
